/**
 * The consent cookie. Renamed from "cookie-consent" on 2026-10-01: until
 * then the site stored "all" silently on a first visit, so a value under the
 * old name records no actual choice and is ignored.
 */
export const CONSENT_COOKIE = "caire-consent-v2";
export const LEGACY_CONSENT_COOKIE = "cookie-consent";

// Helper function to reopen cookie consent dialog
export const openCookieConsent = () => {
  window.dispatchEvent(new CustomEvent("openCookieConsent"));
};
